import moment from 'moment';
import { DynamicObjectInterface } from '../type';
import './axiosInterceptor';
import { LoggerService } from '../../ui/utils';
import generateReport from './generateReportService';

interface reportResponse {
  status: Boolean;
  blob?: Blob;
  fileName?: string;
}

const ReportService = {
  async getReport(name: string, campaignDetail: DynamicObjectInterface): Promise<reportResponse> {
    let workbook;
    let fileName = '';
    let blob;
    try {
      if (name === 'team') {
        workbook = await generateReport.teamListReport(name, campaignDetail);
        fileName = `Report_Team_List_${moment.utc().format('YYYYMMDDHHmmss')}.xlsx`;
      } else if (name === 'coach-group') {
        workbook = await generateReport.coachGroupReport(name, campaignDetail);
        fileName = `Report_Coach_List_${moment.utc().format('YYYYMMDDHHmmss')}.xlsx`;
      } else if (name === 'coach-individual') {
        workbook = await generateReport.coachIndividualReport(name, campaignDetail);
        fileName = `Report_Coach_Individual_List_${moment.utc().format('YYYYMMDDHHmmss')}.xlsx`;
      } else if (name === 'leader') {
        workbook = await generateReport.leaderListReport(name, campaignDetail);
        fileName = `Report_Leader_List_${moment.utc().format('YYYYMMDDHHmmss')}.xlsx`;
      } else if (name === 'inventory') {
        workbook = await generateReport.inventoryReport(name, campaignDetail);
        fileName = `Report_Promotion_Inventory_List_${moment.utc().format('YYYYMMDDHHmmss')}.xlsx`;
      } else if (name === 'promo-redemption') {
        workbook = await generateReport.promoRedemptionReport(name, campaignDetail);
        fileName = `Report_Promotion_Redemption_List_${moment.utc().format('YYYYMMDDHHmmss')}.xlsx`;
      }

      if (workbook) {
        await workbook.xlsx.writeBuffer().then((buffer: DynamicObjectInterface) => {
          blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
        });
      }
      return { blob: blob, fileName: fileName, status: true };
    } catch (err) {
      LoggerService.log('Error getReport', err);
      return { status: false };
    }
  },
};
export default ReportService;
